import {NavLink, useParams} from "react-router-dom";

function UserDetailPage() {
    const params = useParams();

    return (
        <>
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Admin</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <NavLink to="/management/organizations"
                                                 className={({isActive}) => isActive ? 'active breadcrumb-item' : 'breadcrumb-item'}
                                                 end>Admin</NavLink></li>
                                    <li className="breadcrumb-item">
                                        <NavLink to="/management/organizations/users"
                                                 className={({isActive}) => isActive ? 'active breadcrumb-item' : 'breadcrumb-item'}
                                                 end>Users</NavLink></li>
                                    <li className="breadcrumb-item active">{params.userId}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="card card-solid">
                        {params.userId}
                    </div>
                </section>
            </div>
        </>
    );
}

export default UserDetailPage;
